import { PlaceholdersService, type Placeholder } from '@/types/generated'
import { ref } from 'vue'
import { defineStore } from 'pinia'

export const usePlaceholderStore = defineStore('placeholderStore', () => {
  const placeholders = ref<Placeholder[]>([])
  const fetchPlaceholders = async () => {
    const response = await PlaceholdersService.placeholdersList()
    placeholders.value.push(...response)
    return response
  }

  return {
    placeholders,
    fetchPlaceholders
  }
})
